import { Store, Module, ActionContext } from 'vuex'
import LoginResult from '@/store/models/login-result'

interface SessionState {
	user: LoginResult,
}
class SessionStore implements Module<SessionState, any> {
	namespaced = true
	state = {
		user: new LoginResult(),
	}
	mutations = {
		setUser(state: SessionState, payload: LoginResult) {
			state.user = payload
		}
	}
	actions = {
	}
}
const session = new SessionStore()
export default session
